import React, { useEffect, useState } from "react";
import { doc, getDoc, updateDoc, Timestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useParams, useNavigate } from "react-router-dom";
import UserSearchSelect from "../components/UserSearchSelect";

const EditBenefit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBenefit = async () => {
      const ref = doc(db, "benefits", id);
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setForm({
          ...data,
          investmentDate: data.investmentDate
            ?.toDate()
            .toISOString()
            .substring(0, 10),
        });
      }
      setLoading(false);
    };
    fetchBenefit();
  }, [id]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    await updateDoc(doc(db, "benefits", id), {
      clientId: form.clientId,
      clientName: form.clientName,
      bdaId: form.bdaId,
      planName: form.planName,
      investmentAmount: Number(form.investmentAmount),
      oneTimeIncome: Number(form.oneTimeIncome),
      investmentDate: Timestamp.fromDate(new Date(form.investmentDate)),
      remarks: form.remarks || "",
      updatedAt: Timestamp.now(),
    });

    navigate("/admin/other-benefits");
  };

  if (loading || !form) return <div>Loading...</div>;

  return (
    <div className="admin-home">
      <h2>Edit Other Benefit</h2>
      <UserSearchSelect
        onUserSelect={(user) =>
          setForm((prev) => ({ ...prev, bdaId: user.bdaId }))
        }
      />
      <form onSubmit={handleSubmit} className="benefit-form">
        <div className="benefit-grid">
          <div className="form-group">
            <label>BDA ID</label>
            <input value={form.bdaId || ""} disabled />
          </div>
          <div className="form-group">
            <label>Client ID</label>
            <input
              name="clientId"
              value={form.clientId}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Client Name</label>
            <input
              name="clientName"
              value={form.clientName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Plan Name</label>
            <input
              name="planName"
              value={form.planName}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Investment Date</label>
            <input
              type="date"
              name="investmentDate"
              value={form.investmentDate}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>Investment Amount</label>
            <input
              type="number"
              name="investmentAmount"
              value={form.investmentAmount}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label>One-Time Income</label>
            <input
              type="number"
              name="oneTimeIncome"
              value={form.oneTimeIncome}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group full-width">
            <label>Remarks</label>
            <textarea
              name="remarks"
              rows="3"
              value={form.remarks || ""}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="admin-button primary">
            Update Benefit
          </button>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate(-1)}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditBenefit;
